export const EMAIL = "hello@skywire.co.uk";
export const CU_EMAIL =
    "a.t.901505346646.u-82757929.54b62835-9f5c-4104-bd57-03160d4f57ae@tasks.clickup.com";
export const EMAIL_CAREERS = "careers@skywire.co.uk";
export const EMAIL_SUBJECT = "Website Enquiry";
export const EMAIL_FROM = "site@skywire.co.uk";
export const EMAIL_FROM_NAME = "Skywire Enquiries";
export const MAIL_TO = `mailto:${EMAIL}?subject=${encodeURIComponent(EMAIL_SUBJECT)}`;
export const PHONE = "+447519518172";
export const PHONE_FORMATTED = "+44 (0)7519 518172";

export const LOCATION = "2 Swinton House,<br/> 85 Gloucester Terrace,<br/> London W2 3HB";
export const LOCATION_LINK = "https://maps.app.goo.gl/nbTxRioSvpPSLFY2A";

export const SOCIAL_INSTAGRAM = "https://www.instagram.com/skywire_agency/";
export const SOCIAL_LINKEDIN = "https://www.linkedin.com/company/skywire-agency/";
export const SOCIAL_FACEBOOK = "https://www.facebook.com/skywirelondon/";

export const DEFAULT_META_TITLE = "Skywire | Luxury Digital Agency & Growth Partner";
export const DEFAULT_META_DESCRIPTION =
    "Skywire is a luxury digital agency and growth partner combining technology and engineering, creative experience and performance marketing.";

export const DOCS_URL = "https://skywire.co.uk";

export const COPYRIGHT_ENTITY = "\u00a9"; // (c)
export const H_ELLIPSIS_ENTITY = "\u2026"; // ...
export const VERTICAL_LINE_ENTITY = "\u007c"; // |

export const BLOG_NAME = "News + Thought";

export const SITE_URL = "https://skywire.co.uk";
